/**
 * Copyright (c) 2019 2020 2021 2022 AIGIA. All Rights Reserved.
 * see license.txt
 */
import {IContent} from "../platform/universe";
import mongoose from "mongoose";

export enum AuthLevel {
	system = 1,
	manager = 100,
	company = 120,
	studio = 130,
	trainer = 150,
	user = 200,
	public = 100000,
}

export interface IInquiryModel {
	id: any,
	username: string;
	category: string;
	status: number;
	question: string,
	answer: string,
}

export interface IInquiryModelContent {
	id: any,
	username: string;
	category: string;
	status: number;
	question: string,
	answer: string,
	title: string,
	contentname: string,
	contentdescription: string,
	hascancel:boolean;
}

export interface IParagraphModelContent extends IContent {
	name: string;
	value: string;
	accessory: {};
}

export interface IGuestPublic {
	username: string;
	user_id: mongoose.Types.ObjectId;
	auth: number;
	category: string;
	status: number;
	type: string;
	enabled: boolean;
	subscribe: number;
	relations:any;
	parent: mongoose.Types.ObjectId;
	depth:number;
	gender: number;
	year_of_birth: number;
	average_score: string;
	date_update_profile: Date;
}


export interface IGuestUserToken {
	auth: number;
	username: string;
	password: string;
	category: string,
	type: string,
	origin:string,
	content: {};
	target: string;
	lang:string;
	timestamp: any;
}
